module.exports = __webpack_public_path__ + "img/screenShow3.37b4521.png";